import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=f85736cc&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f85736cc')) {
      api.createRecord('f85736cc', component.options)
    } else {
      api.reload('f85736cc', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=f85736cc&", function () {
      api.rerender('f85736cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS8CvN2eu39c/JS/comp/openstreetmap.vue"
export default component.exports